import { create } from 'zustand';
import update from 'immutability-helper';
import { initialState } from '@src/store/common/reducer';
import { get } from 'lodash';
import { useMemo } from 'react';
// import featureNames from '@utils/featureToggle/constants';

// this store can eventually replace redux store for managing features

export const useFeatureStore = create((set) => initialState.features);

export const initFeatureStore = (dbState) =>
  useFeatureStore.setState((state) => ({ ...state, ...dbState }));

// use this only for local feature flags
// we can use a local- prefix
// TODO: needs discussion, this could replace checkFeature logic
export const updateFeatureValue = (feature, value) =>
  useFeatureStore.setState((state) => {
    return update(state, {
      [feature]: { $set: value },
    });
  });

// without subscription
export const getFeature = (featureName) => {
  const features = useFeatureStore.getState();
  return get(features, [featureName], null);
};

// with subscription
export const useFeature = (featureName) => {
  const features = useFeatureStore((features) => features);
  const featureValue = useMemo(() => get(features, [featureName], null), [features, featureName]);
  return featureValue;
};
